import api from './api';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
}

export interface User {
  id: number;
  name: string;
  email: string;
  phone?: string;
  department?: string;
  position?: string;
  roles?: string[];
  permissions?: string[];
}

export const authService = {
  async login(credentials: LoginCredentials) {
    const response = await api.post('/login', credentials);
    const { token, user } = response.data.data;
    localStorage.setItem('token', token);
    return { token, user };
  },

  async register(data: RegisterData) {
    const response = await api.post('/register', data);
    const { token, user } = response.data.data;
    localStorage.setItem('token', token);
    return { token, user };
  },

  async logout() {
    await api.post('/logout');
    localStorage.removeItem('token');
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get('/user');
    return response.data.data;
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('token');
  },
};
